import { ButtonVariant } from "@repo/ui/Buttons/button";
import { IconButton } from "@repo/ui/Buttons/iconButton";
import { IconPlayerPause, IconPlayerPlay } from "@tabler/icons-react";
import type { FC } from "react";
import { AudioPlayerTrigger } from "./audioPlayerTrigger.js";

export interface AudioPlayerPlayButtonProps {
  sourceKey: string;
}

export const AudioPlayerPlayButton: FC<AudioPlayerPlayButtonProps> = (
  props,
) => {
  return (
    <AudioPlayerTrigger sourceKey={props.sourceKey}>
      {({ isPlaying, onPress }) => (
        <IconButton
          variant={ButtonVariant.Tertiary}
          icon={
            isPlaying ? (
              <IconPlayerPause className="size-4 text-muted-foreground" />
            ) : (
              <IconPlayerPlay className="size-4 text-muted-foreground" />
            )
          }
          onClick={onPress}
        />
      )}
    </AudioPlayerTrigger>
  );
};
